// extracted by mini-css-extract-plugin
export default {"contents":"IF-z","sectionHeading":"JF-z"};